<template>	
		<section class="announcement_form">
            <h1 class="text-dark">Edit Announcement</h1>
			<div class="row ">
				<div class="form-group col-sm-3 mb-4">
					<BaseInput
						name="Announcement"
						label="Announcement"
						type="text"
						v-model="data.announcement"
						class="form-control form-control-lg dashInput"
						rules="required"
						:required="true"
					/>
				</div>
				<div class="col-sm-3">
					<BaseMultiSelect
						@update:value="setForRole"
						:options="multiSelectState.rolesSelect"
                        :defaultData="data.forRoles"
						name="For Roles"
						mode="tags"
					/>
				</div>
				<div class="col-sm-3">
					<BaseMultiSelect
						@update:value="setForUsers"
						:options="multiSelectState.usersSelect"
                        :defaultData="data.forUsers"
						name="For Users"
						mode="tags"
					/>
				</div>
				<div class="col-sm-3">
					<BaseInput
						name="Valid Till"
						label="Valid Till"
						type="Date"
						v-model="data.validTill"
						class="form-control form-control-lg dashInput"
						rules="required"
						:required="true"
					/>
				</div>
				<div class="col-sm-3">
					<BaseButton
						class="btn btn-primary form-control form-control-lg"
						type="submit"
						label="Save Announcement"
						@on:Click="updateAnnouncement()"
						:disabled="formState.disable"
						:loading="formState.isLoading"
					/>
				</div>
			</div>
		</section>

</template>
<script>
	import { reactive, inject, onMounted } from "vue";
	import { useRouter } from "vue-router";

	import API from "@/config/api";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";

	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseInput from "./BaseInput.vue";
	import BaseButton from "./BaseButton.vue"; 

	export default {
		name: "announcementEdit",
		components: {
		    BaseMultiSelect,
			BaseInput,
			BaseButton
		},

		setup: () => {
			const store = inject("store");
			const masterStore = inject("masterStore");
            const router = useRouter();

			// if (!store.state.auth.isAuth) router.push({ name: "Login"});
			
            const data = reactive({
				announcement: null,
				forRoles: [],
				forUsers: [],
				validTill: null,
			});

			const formState = reactive({
				isLoading: false,
				disable: false,
			});

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: [],
			});

            const multiSelectState = reactive({
				roles: [],
				rolesSelect: Helper.roles.map((role) => ({
					value: role,
					label: role.replace(/_/g, " "),
				})),
				users: [],
				usersSelect: [],
			});

		
	

			const updateAnnouncement = async () => {
				try {
					const response = await API.privateRequest.patch(
						`admin/announcements/${masterStore.state.editId}`,
						data,
					);

					toast.success("Tag Updated!");
					masterStore.methods.setId("edit", null);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

            const getUsers = async () => {
				try {
					const users = await API.privateRequest.get("/users?filter=1");
					multiSelectState.users = users.data.data;
					multiSelectState.usersSelect = users.data.data.map((item) => {
						return {
							value: item._id,
							label: `${item.firstName} ${item.lastName}`,
						};
					});
                    setEditData();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

            const setEditData = () => {
                if (!masterStore.state.activeComponent === "edit") return;

                //setting edit data in state
                data.validTill =  masterStore.state.data.validTill.split("T")[0] || null;
                data.forUsers =[...masterStore.state.data.forUsers.map( user => user._id)] || [];
                data.forRoles = [...masterStore.state.data.forRoles] || [];
                data.announcement = masterStore.state.data.announcement ||  null;
                
            }

			const setForRole = (payload) => {
				data.forRoles = [...payload];
				getUsers();
			};
			const setForUsers = (payload) => {
				data.forUsers = [...payload];
			};

			onMounted(
				() => {
					getUsers();
                    
				}
			)

			//? checking conditions to enable or disable form login button
			// const checkForm = () => {
			// 	let inValLength = validation.invalid.length;

			// 	if (inValLength) {
			// 		formState.disable = true;
			// 	} else formState.disable = false;
			// };

			//? adding and removing form fields from valid and invalid state
			// const setFormVal = (data) => {
			// 	if (validation.invalid.length) {
			// 		const newInvalid = validation.invalid.filter(
			// 			(error) => error.field !== data.field,
			// 		);
			// 		validation.invalid = newInvalid;
			// 	}
			// 	if (validation.valid.length) {
			// 		const newValid = validation.valid.filter(
			// 			(item) => item.field !== data.field,
			// 		);
			// 		validation.valid = newValid;
			// 	}
			// 	return;
			// };

			// event handler for valError event
			const valError = (data) => {
				// setFormVal(data);
				// validation.invalid = [...validation.invalid, data];
				// checkForm();
			};

			const valSuccess = (data) => {
				// setFormVal(data);
				// validation.valid = [...validation.valid, data];
				// checkForm();
			};

			return {
				data,
                multiSelectState,
				updateAnnouncement,
                setForRole,
                setForUsers,
				valError,
				valSuccess,
				formState,
			};
		},
	};
</script>
